import { create } from 'zustand';
import { toggleWaterThreshold, updateWaterThreshold } from '../../../api/api';
import { toast } from 'react-toastify';

export const useThresholdStore = create((set, get) => ({
  threshold: null,
  setThreshold: (threshold) => set(() => ({ threshold })),

  updateThreshold: async (deviceId) => {
    const { threshold, setThreshold } = get();

    if (deviceId && threshold?.daily_threshold) {
      const body = { device_id: deviceId, daily_threshold: Number(threshold.daily_threshold) };

      await updateWaterThreshold(body, function (err) {
        if (err?.error) {
          toast.error(err.error, { hideProgressBar: true });
        }
      });

      setThreshold(null);
    }
  },

  updateStatusThreshold: async (is_active) => {
    const { threshold } = get();

    if (threshold?.id) {
      const body = { threshold_id: threshold?.id, is_active };

      await toggleWaterThreshold(body, function (err) {
        if (err?.error) {
          toast.error(err.error, { hideProgressBar: true });
        }
      });
    }
  },
}));
